import React from 'react';
import { gql } from '@yi/core';

import { graphql } from 'gatsby';
import { HelmetTags, MainLayout, useAlgoliaProductViewedEvent, useLocale } from '~/components';

import { MidArticleFunnel, PoseContent } from './common';

type PageViewData = React.ComponentProps<typeof MainLayout>['pageViewData'];
export const Pose: React.FC<{ data: gql.typesSsr.Query_Pose }> = ({ data }) => {
  const { yi } = data;
  if (!yi) return null;
  return <PosePage content={yi.Pose} />;
};

interface Props {
  content: Omit<gql.typesSsr.Query_Pose_yi_Pose, '__typename'>;
}

export const PosePage: React.FC<Props> = ({ content }) => {
  const { locale } = useLocale();
  const {
    title,
    seo_title,
    seo_description,
    id,
    short_summary,
    entry_date,
    full_url,
    no_text_image: { processed_url },
  } = content;

  const indexName = `articles_${locale}`;
  useAlgoliaProductViewedEvent({ contentID: id, indexName });

  const pageViewData: PageViewData = {
    contentAuthor: 'Yoga International',
    contentChannel: 'Yoga',
    contentTopic: 'Pose',
    contentPubDate: entry_date.yyyymmdd,
    contentTitle: title,
    contentId: id,
  };

  return (
    <MainLayout pageTitle={title} pageViewData={pageViewData}>
      <HelmetTags
        entry_type={gql.typesSsr.ArticleType.POSE}
        teacherName="Yoga International"
        short_summary={short_summary}
        title={title}
        seo_title={seo_title}
        seo_description={seo_description}
        entry_date={entry_date}
        url={full_url}
        image_url={processed_url}
      />
      <article id="{url_title}">
        <PoseContent pose={content} />
      </article>
      <MidArticleFunnel />
    </MainLayout>
  );
};

export const query = graphql`
  query Query_Pose($id: ID!) {
    yi {
      Pose(id: $id) {
        id
        title
        subtitle
        url_title
        full_url
        entry_date {
          iso8601
          yyyymmdd
        }
        no_text_image(params: { width: 1600, format: webp }) {
          processed_url
        }
        short_summary
        seo_title
        seo_description
        parsed_body(params: { width: 800 })
        pose_category {
          id
          name
        }
        pose_type {
          id
          name
        }
        pose_pronunciation_text
        pose_pronunciation_audio_url
        next {
          localized_path
        }
        prev {
          localized_path
        }
      }
    }
  }
`;

// eslint-disable-next-line import/no-default-export
export default Pose;
